<po-page-default
  [p-actions]="pageActions">

  <!-- Período, origem, área e tipo são um recorte só e dividem a mesma po-row, como no
       painel de custos. `inline` põe os campos do período direto nesta linha, em vez de ele abrir
       uma linha só dele e empurrar a origem para baixo. -->
  <div class="po-row po-mb-3">
    <app-period-filter
      [inline]="true"
      rangeClass="po-sm-12 po-md-8 po-lg-4"
      [period]="period"
      (periodChange)="onPeriodChange($event)">
    </app-period-filter>

    <po-multiselect
      class="po-sm-12 po-md-4 po-lg-3"
      name="statsSourceProvider"
      p-label="Origem"
      p-placeholder="Todas as origens"
      p-filter-mode="contains"
      [p-options]="sourceProviderOptions"
      [(ngModel)]="selectedSourceProviders"
      (ngModelChange)="onSourceProviderChange($event)">
    </po-multiselect>

    <!-- Área, solicitante e tipo recortam pelo pedido do review, como o dashboard de reviews. -->
    <po-multiselect
      class="po-sm-12 po-md-4 po-lg-3"
      name="statsArea"
      p-label="Área"
      p-placeholder="Todas as áreas"
      p-filter-mode="contains"
      [p-options]="areaOptions"
      [(ngModel)]="selectedAreas"
      (ngModelChange)="onAreaChange($event)">
    </po-multiselect>

    <!-- Solicitante é quem pediu o review (o "Usuário" do dashboard), não quem votou. -->
    <po-multiselect
      class="po-sm-12 po-md-4 po-lg-3"
      name="statsRequestedBy"
      p-label="Solicitante"
      p-placeholder="Todos os solicitantes"
      p-filter-mode="contains"
      [p-options]="requesterOptions"
      [(ngModel)]="selectedRequesters"
      (ngModelChange)="onRequesterChange($event)">
    </po-multiselect>

    <po-multiselect
      class="po-sm-12 po-md-4 po-lg-3"
      name="statsResourceType"
      p-label="Tipo de review"
      p-placeholder="Todos os tipos"
      p-filter-mode="contains"
      [p-options]="resourceTypeOptions"
      [(ngModel)]="selectedResourceTypes"
      (ngModelChange)="onResourceTypeChange($event)">
    </po-multiselect>
  </div>

  <p class="curation-period-hint" *ngIf="hasSnapshotScope">
    O período aplica-se apenas aos cards marcados como <strong>No período</strong>.
    Os cards <strong>Estado atual</strong> refletem sempre a situação atual, independente do filtro.
  </p>

  <po-loading-overlay *ngIf="loading" p-size="md" p-text="Carregando"></po-loading-overlay>

  <ng-container *ngIf="!loading">

    <ng-template #indicatorEmpty>
      <p class="curation-empty curation-empty--indicator">Não há dados ainda para este período.</p>
    </ng-template>

    <ng-template #chartEmpty>
      <div class="curation-chart-empty">
        <p class="curation-empty">Não há dados ainda para este período.</p>
      </div>
    </ng-template>

    <ng-template #largeChartEmpty>
      <div class="curation-chart-empty curation-chart-empty--large">
        <p class="curation-empty">Não há dados ainda para este período.</p>
      </div>
    </ng-template>

    <!-- Funil por status -->
    <div class="po-row po-mb-3">
      <po-widget class="po-md-4" p-title="Pendentes">
        <po-tag *ngIf="scopeBadge('pending') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <div class="curation-highlight">
          <span class="curation-highlight__value">{{ funnel.pending }}</span>
          <span class="curation-highlight__label">aguardando curadoria</span>
        </div>
      </po-widget>
      <po-widget class="po-md-4" p-title="Curados">
        <po-tag *ngIf="scopeBadge('curated') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <div class="curation-highlight">
          <span class="curation-highlight__value">{{ funnel.curated }}</span>
          <span class="curation-highlight__label">no golden set</span>
        </div>
      </po-widget>
      <po-widget class="po-md-4" p-title="Descartados">
        <po-tag *ngIf="scopeBadge('discarded') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <div class="curation-highlight">
          <span class="curation-highlight__value">{{ funnel.discarded }}</span>
          <span class="curation-highlight__label">fora do golden set</span>
        </div>
      </po-widget>
    </div>

    <!-- Destaques -->
    <div class="po-row po-mb-3">
      <po-widget class="po-md-2" p-title="Itens com ação de melhoria">
        <po-tag *ngIf="scopeBadge('byLever') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="cardHelp.fixablePct" p-tooltip-position="bottom" p-append-in-body="true"></span>
        <div class="curation-highlight">
          <span class="curation-highlight__value">{{ fixablePctLabel }}</span>
          <span class="curation-highlight__label">acionável (vs. não corrigível)</span>
        </div>
        <po-info
          p-label="Total curado"
          p-orientation="horizontal"
          [p-value]="funnel.curated.toString()">
        </po-info>
      </po-widget>

      <po-widget class="po-md-4" p-title="Alavanca principal">
        <po-tag *ngIf="scopeBadge('byLever') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="cardHelp.primaryLever" p-tooltip-position="bottom" p-append-in-body="true"></span>
        <ng-container *ngIf="primaryLeverIndicator as primaryLever; else indicatorEmpty">
          <div class="curation-highlight">
            <span class="curation-highlight__value curation-highlight__value--text">{{ primaryLever.label }}</span>
            <span class="curation-highlight__label">{{ primaryLever.pct }} dos itens curados</span>
          </div>
          <po-info
            p-label="Itens"
            p-orientation="horizontal"
            [p-value]="primaryLever.count.toString()">
          </po-info>
        </ng-container>
      </po-widget>

      <po-widget class="po-md-3" p-title="Taxa de falso positivo">
        <po-tag *ngIf="scopeBadge('votes') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="cardHelp.fpRate" p-tooltip-position="bottom" p-append-in-body="true"></span>
        <ng-container *ngIf="hasVotes; else indicatorEmpty">
          <div class="curation-highlight">
            <span class="curation-highlight__value">{{ fpRateLabel }}</span>
            <span class="curation-highlight__label">dos votos foram falso positivo</span>
          </div>
          <div class="curation-votes-info">
            <span class="curation-votes-info__label">Votos:</span>
            <span class="curation-votes-cell">
              <span class="curation-vote curation-vote--tp"
                [class.curation-vote--active]="(stats!.votes!.truePositive ?? 0) > 0"
                [p-tooltip]="voteTooltips.truePositive" p-tooltip-position="top" p-append-in-body="true">{{ stats!.votes!.truePositive }} TP</span>
              <span class="curation-vote curation-vote--fp"
                [class.curation-vote--active]="(stats!.votes!.falsePositive ?? 0) > 0"
                [p-tooltip]="voteTooltips.falsePositive" p-tooltip-position="top" p-append-in-body="true">{{ stats!.votes!.falsePositive }} FP</span>
              <span class="curation-vote curation-vote--wf"
                [class.curation-vote--active]="(stats!.votes!.wontFix ?? 0) > 0"
                [p-tooltip]="voteTooltips.wontFix" p-tooltip-position="top" p-append-in-body="true">{{ stats!.votes!.wontFix }} WF</span>
            </span>
          </div>
        </ng-container>
      </po-widget>

      <po-widget class="po-md-3" p-title="Taxa de correção">
        <po-tag *ngIf="scopeBadge('votes') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="cardHelp.fixRate" p-tooltip-position="bottom" p-append-in-body="true"></span>
        <ng-container *ngIf="hasVotes; else indicatorEmpty">
          <div class="curation-highlight">
            <span class="curation-highlight__value">{{ fixRateLabel }}</span>
            <span class="curation-highlight__label">dos achados válidos serão corrigidos</span>
          </div>
          <po-info
            p-label="Corrigir / Não corrigir"
            p-orientation="horizontal"
            [p-value]="stats!.votes!.truePositive + ' / ' + stats!.votes!.wontFix">
          </po-info>
        </ng-container>
      </po-widget>
    </div>

    <!-- Saúde do processo -->
    <div class="po-row po-mb-3" *ngIf="hasTimeToCurate || hasConsensus || hasBacklogAging">
      <po-widget class="po-md-4" p-title="Tempo até curar">
        <po-tag *ngIf="scopeBadge('timeToCurateHours') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="cardHelp.timeToCurate" p-tooltip-position="bottom" p-append-in-body="true"></span>
        <ng-container *ngIf="hasTimeToCurate; else indicatorEmpty">
          <div class="curation-highlight">
            <span class="curation-highlight__value">{{ timeToCurateAvgLabel }}</span>
            <span class="curation-highlight__label">média (mediana {{ timeToCurateMedianLabel }})</span>
          </div>
        </ng-container>
      </po-widget>
      <po-widget class="po-md-4" p-title="Concordância entre devs">
        <po-tag *ngIf="scopeBadge('consensusRate') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="cardHelp.consensus" p-tooltip-position="bottom" p-append-in-body="true"></span>
        <ng-container *ngIf="hasConsensus; else indicatorEmpty">
          <div class="curation-highlight">
            <span class="curation-highlight__value">{{ consensusLabel }}</span>
            <span class="curation-highlight__label">dos achados multi-dev têm consenso</span>
          </div>
        </ng-container>
      </po-widget>
      <po-widget class="po-md-4" p-title="Backlog mais antigo">
        <po-tag *ngIf="scopeBadge('backlogAgingDays') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="cardHelp.backlogOldest" p-tooltip-position="bottom" p-append-in-body="true"></span>
        <ng-container *ngIf="hasBacklogAging; else indicatorEmpty">
          <div class="curation-highlight">
            <span class="curation-highlight__value">{{ backlogOldestLabel }}</span>
            <span class="curation-highlight__label">pendente há mais tempo</span>
          </div>
        </ng-container>
      </po-widget>
    </div>

    <!-- Cobertura de feedback -->
    <div class="po-row po-mb-3" *ngIf="hasCoverage">
      <po-widget class="po-md-6" p-title="Cobertura de feedback (achados)">
        <po-tag *ngIf="scopeBadge('coverage') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="cardHelp.findingsCoverage" p-tooltip-position="bottom" p-append-in-body="true"></span>
        <div class="curation-highlight">
          <span class="curation-highlight__value">{{ findingsCoverageLabel }}</span>
          <span class="curation-highlight__label">dos achados avaliados</span>
        </div>
        <po-info
          p-label="Sem feedback"
          p-orientation="horizontal"
          [p-value]="findingsWithoutFeedback.toString()">
        </po-info>
      </po-widget>
      <po-widget class="po-md-6" p-title="Cobertura de feedback (reviews)">
        <po-tag *ngIf="scopeBadge('coverage') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="cardHelp.reviewsCoverage" p-tooltip-position="bottom" p-append-in-body="true"></span>
        <div class="curation-highlight">
          <span class="curation-highlight__value">{{ reviewsCoverageLabel }}</span>
          <span class="curation-highlight__label">dos reviews avaliados</span>
        </div>
        <po-info
          p-label="Sem feedback"
          p-orientation="horizontal"
          [p-value]="reviewsWithoutFeedback.toString()">
        </po-info>
      </po-widget>
    </div>

    <ng-container *ngIf="hasData; else empty">

      <div class="po-row po-mb-3">
        <po-widget class="po-md-6" p-title="Itens por alavanca de melhoria (lever)">
          <po-tag *ngIf="scopeBadge('byLever') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
          <po-chart
            *ngIf="leverCategories.length; else chartEmpty"
            [p-type]="barType"
            [p-categories]="leverCategories"
            [p-series]="leverSeries"
            [p-height]="rowChartHeight(leverChartHeight, categoryChartHeight)">
          </po-chart>
        </po-widget>

        <po-widget class="po-md-6" p-title="Quantidade por categoria">
          <po-tag *ngIf="scopeBadge('byCategory') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
          <po-chart
            *ngIf="categoryCategories.length; else chartEmpty"
            [p-type]="barType"
            [p-categories]="categoryCategories"
            [p-series]="categorySeries"
            [p-height]="rowChartHeight(leverChartHeight, categoryChartHeight)">
          </po-chart>
        </po-widget>
      </div>

      <div class="po-row po-mb-3">
        <po-widget class="po-md-6" p-title="Itens curados por linguagem">
          <po-tag *ngIf="scopeBadge('byLanguage') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
          <po-chart
            *ngIf="languageCategories.length; else chartEmpty"
            [p-type]="barType"
            [p-categories]="languageCategories"
            [p-series]="languageSeries"
            [p-height]="languageChartHeight">
          </po-chart>
        </po-widget>

        <po-widget class="po-md-6" p-title="Por tipo de review">
          <po-tag *ngIf="scopeBadge('byResourceType') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
          <po-chart *ngIf="resourceTypeSeries.length; else chartEmpty" [p-type]="donutType" [p-series]="resourceTypeSeries" [p-height]="280"></po-chart>
        </po-widget>
      </div>

      <div class="po-row po-mb-3">
        <po-widget class="po-md-6" p-title="Por tipo de achado">
          <po-tag *ngIf="scopeBadge('byFindingKind') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
          <po-chart *ngIf="findingKindSeries.length; else chartEmpty" [p-type]="donutType" [p-series]="findingKindSeries" [p-height]="280"></po-chart>
        </po-widget>

        <po-widget class="po-md-6" [p-title]="curatorChartTitle">
          <po-tag *ngIf="scopeBadge('byCurator') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
          <po-chart
            *ngIf="curatorCategories.length; else chartEmpty"
            [p-type]="barType"
            [p-categories]="curatorCategories"
            [p-series]="curatorSeries"
            [p-height]="curatorChartHeight">
          </po-chart>
        </po-widget>
      </div>

      <div class="po-row po-mb-3">
        <po-widget class="po-md-6" [p-title]="feedbackUserChartTitle">
          <po-tag *ngIf="scopeBadge('byFeedbackUser') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
          <po-chart
            *ngIf="feedbackUserCategories.length; else chartEmpty"
            [p-type]="barType"
            [p-categories]="feedbackUserCategories"
            [p-series]="feedbackUserSeries"
            [p-height]="feedbackUserChartHeight">
          </po-chart>
        </po-widget>

        <po-widget class="po-md-6" p-title="Curadorias ao longo do tempo">
          <po-tag *ngIf="scopeBadge('overTime') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
          <po-chart
            *ngIf="overTimeSeries.length; else chartEmpty"
            [p-type]="lineType"
            [p-categories]="overTimeCategories"
            [p-series]="overTimeSeries"
            [p-height]="280">
          </po-chart>
        </po-widget>
      </div>

    </ng-container>

    <ng-template #empty>
      <div class="po-row po-mb-3">
        <po-widget class="po-md-12" p-title="Itens curados">
          <p class="curation-empty">Não há dados ainda para este período.</p>
        </po-widget>
      </div>
    </ng-template>

    <!-- Precisão do modelo (taxa de FP por dimensão) -->
    <div class="po-row po-mb-3" *ngIf="verdictSeries.length || goldenBalanceSeries.length">
      <po-widget class="po-md-6" p-title="Distribuição de vereditos">
        <po-tag *ngIf="scopeBadge('votes') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="cardHelp.verdictDistribution" p-tooltip-position="bottom" p-append-in-body="true"></span>
        <po-chart *ngIf="verdictSeries.length; else chartEmpty" [p-type]="donutType" [p-series]="verdictSeries" [p-height]="280"></po-chart>
      </po-widget>
      <po-widget class="po-md-6" p-title="Balanço do golden set">
        <po-tag *ngIf="scopeBadge('goldenBalance') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="cardHelp.goldenBalance" p-tooltip-position="bottom" p-append-in-body="true"></span>
        <po-chart *ngIf="goldenBalanceSeries.length; else chartEmpty" [p-type]="donutType" [p-series]="goldenBalanceSeries" [p-height]="280"></po-chart>
      </po-widget>
    </div>

    <div class="po-row po-mb-3" *ngIf="fpByLanguageSeries.length || fpBySeveritySeries.length">
      <po-widget class="po-md-6" p-title="Taxa de falso positivo por linguagem (%)">
        <po-tag *ngIf="scopeBadge('votesByLanguage') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <po-chart *ngIf="fpByLanguageSeries.length; else chartEmpty" [p-type]="barType" [p-categories]="fpByLanguageCategories" [p-series]="fpByLanguageSeries" [p-height]="rowChartHeight(fpByLanguageChartHeight, fpBySeverityChartHeight)"></po-chart>
      </po-widget>
      <po-widget class="po-md-6" p-title="Taxa de falso positivo por severidade (%)">
        <po-tag *ngIf="scopeBadge('votesBySeverity') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <po-chart *ngIf="fpBySeveritySeries.length; else chartEmpty" [p-type]="barType" [p-categories]="fpBySeverityCategories" [p-series]="fpBySeveritySeries" [p-height]="rowChartHeight(fpByLanguageChartHeight, fpBySeverityChartHeight)"></po-chart>
      </po-widget>
    </div>

    <div class="po-row po-mb-3" *ngIf="fpByFindingKindSeries.length || fpByResourceTypeSeries.length">
      <po-widget class="po-md-6" p-title="Taxa de falso positivo por tipo de achado (%)">
        <po-tag *ngIf="scopeBadge('votesByFindingKind') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <po-chart *ngIf="fpByFindingKindSeries.length; else chartEmpty" [p-type]="barType" [p-categories]="fpByFindingKindCategories" [p-series]="fpByFindingKindSeries" [p-height]="rowChartHeight(fpByFindingKindChartHeight, fpByResourceTypeChartHeight)"></po-chart>
      </po-widget>
      <po-widget class="po-md-6" p-title="Taxa de falso positivo por tipo de review (%)">
        <po-tag *ngIf="scopeBadge('votesByResourceType') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <po-chart *ngIf="fpByResourceTypeSeries.length; else chartEmpty" [p-type]="barType" [p-categories]="fpByResourceTypeCategories" [p-series]="fpByResourceTypeSeries" [p-height]="rowChartHeight(fpByFindingKindChartHeight, fpByResourceTypeChartHeight)"></po-chart>
      </po-widget>
    </div>

    <!-- Cross-tabs (linguagem como série) -->
    <div class="po-row po-mb-3" *ngIf="leverByLanguageSeries.length || categoryByLanguageSeries.length">
      <po-widget class="po-md-6" p-title="Alavanca de melhoria (lever) × Linguagem">
        <po-tag *ngIf="scopeBadge('leverByLanguage') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <po-chart *ngIf="leverByLanguageSeries.length; else largeChartEmpty" [p-type]="barType" [p-categories]="leverByLanguageCategories" [p-series]="leverByLanguageSeries" [p-height]="rowChartHeight(leverByLanguageChartHeight, categoryByLanguageChartHeight)"></po-chart>
      </po-widget>
      <po-widget class="po-md-6" p-title="Categoria × Linguagem">
        <po-tag *ngIf="scopeBadge('categoryByLanguage') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <po-chart *ngIf="categoryByLanguageSeries.length; else largeChartEmpty" [p-type]="barType" [p-categories]="categoryByLanguageCategories" [p-series]="categoryByLanguageSeries" [p-height]="rowChartHeight(leverByLanguageChartHeight, categoryByLanguageChartHeight)"></po-chart>
      </po-widget>
    </div>

    <!-- Aging do backlog -->
    <div class="po-row po-mb-3" *ngIf="backlogAgingSeries.length">
      <po-widget class="po-md-6" p-title="Idade do backlog pendente">
        <po-tag *ngIf="scopeBadge('backlogAgingDays') as b" class="curation-scope-badge" [p-value]="b.label" [p-color]="b.period ? '#1f8b97' : '#8a9a9e'"></po-tag>
        <po-chart [p-type]="barType" [p-categories]="backlogAgingCategories" [p-series]="backlogAgingSeries" [p-height]="backlogAgingChartHeight"></po-chart>
      </po-widget>
    </div>

  </ng-container>

</po-page-default>

<notificationComponentHM></notificationComponentHM>
